/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

import { withMsal } from '@azure/msal-react';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  removeItem,
  logUserOut,
  updateUserPreference,
  selectSalesOrg,
  handleSalesOrgDialog,
} from '../../actions/index';
import Header from '../Header/index';
import { getMenuData, getLanguages, getIcons, getCountries } from './config';

class AppHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: [],
      countries: [],
    };
  }

  componentDidMount() {
    try {
      const { t } = this.props;

      const languages = getLanguages(t);
      const countries = getCountries(t);
      this.setState({ languages, countries });
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { t, history, library } = this.props;
    const { languages, countries } = this.state;
    const { userPreference } = library;
    const { auth } = this.props;
    const { loggedIn } = auth;
    const icons = getIcons(this.props);
    const menuData = getMenuData(t, history);

    return (
      <Header
        {...this.props}
        iconsData={icons}
        menuData={menuData}
        languages={languages}
        // countries={countries}
        showHeader={loggedIn}
        userPreference={userPreference}
        width={200}
        height="100%"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    cart: state.cart,
    library: state.library,
    checkout: state.checkout,
  };
};

export default withMsal(
  withSnackbar(
    withTranslation(['libraryScreenTranslations'])(
      withRouter(
        connect(mapStateToProps, {
          removeItem,
          logUserOut,
          updateUserPreference,
          selectSalesOrg,
          handleSalesOrgDialog,
        })(AppHeader)
      )
    )
  )
);
